import * as moment from 'moment';
import { useEffect, useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import DateTimePicker from '@nkr/components/date-time-picker';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    isInternalOrRemote: boolean,
    existingXm: boolean,
    status: string,
    donorAlias: string,
    donorCenterAlias: string,
    donorKidneyPickUpDateTime: string,
    donorKidneyPickUpDateTimeTz: string,
    onSend: (bloodDrawDate: string) => void,
    onCancel: () => void
}

const RequestFinalXm = (props: IProps) => {
    const [bloodDrawDate, setBloodDrawDate] = useState('');
    const [isValid, setIsValid] = useState(true);
    const [dateValid, setDateValid] = useState(true);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setBloodDrawDate('');
            setIsValid(true);
            setDateValid(true);
        }
    }, [props.show]);

    const handleBloodDrawDateChange = (property: string, value: moment.Moment) => {
        setBloodDrawDate(value.format('MM/DD/YY'))
    };

    const handleSend = () => {
        let newIsValid = moment(bloodDrawDate).isValid();

        setIsValid(newIsValid);

        if (newIsValid) {
            let validDateRange = checkDateRange();

            if (validDateRange) {
                props.onSend(bloodDrawDate);
            }
        }
    };

    const checkDateRange = () => {
        let now = moment().utc().startOf('day');
        let date = moment(bloodDrawDate).clone().utc(); 
        let range = moment.tz(props.donorKidneyPickUpDateTime, 'MM/DD/YY HH:mm', handleTimeZone(props.donorKidneyPickUpDateTimeTz)).utc();

        if (date.isSameOrBefore(now) || date.isAfter(range)) {
            setDateValid(false);
            return false;
        } else {
            setDateValid(true);
            return true;
        }
    };

    const isValidDate = (currentDate: any, selectedDate: any) => {
        if (!props.isInternalOrRemote) {
            return true;
        }

        const day = currentDate.day();
        // 0 = Sunday, 5 = Friday, 6 = Saturday
        return day !== 0 && day !== 5 && day !== 6;
    };

    const handleTimeZone = (timeZone: string) => {
        if (timeZone == 'EST' || timeZone == '') {
            return 'America/New_York';
        }

        if (timeZone == 'CST') {
            return 'America/Chicago';
        }

        if (timeZone == 'MST') {
            return 'America/Denver';
        }

        if (timeZone == 'MST-Az'){
            return 'America/Phoenix'
        }

        if (timeZone == 'PST') {
            return 'America/Los_Angeles';
        }

        if (timeZone == 'HST') {
            return 'Pacific/Honolulu';
        }
    }

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Request for Final XM for {props.donorAlias} at {props.donorCenterAlias}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {dateValid == false && (
                    <div className='alert alert-danger text-center' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>{`Range must be a future date no greater than the Scheduled Pick up date of: ${props.donorKidneyPickUpDateTime} ${props.donorKidneyPickUpDateTimeTz}.`} </div>
                )}

                {isValid == false && (
                    <div className='alert alert-danger text-center' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>Please specify a valid blood draw date</div>
                )}

                <div className='text-center'>
                    <div style={{ marginBottom: 20 }}>After entering the requested blood draw date, click the send button to request the final XM.</div>

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label style={{ margin: '0px 5px 0px 0px' }}>Blood Draw Date:</label>
                        <DateTimePicker
                            property=''
                            currentValue={bloodDrawDate}
                            showTime={false}
                            onValueChanged={handleBloodDrawDateChange}
                            isValidDate={isValidDate}
                        />
                    </div>
                </div>

                {props.existingXm &&
                    <div className='alert alert-warning text-center' style={{ marginTop: 20, paddingTop: 7.5, paddingBottom: 7.5 }}>
                        There is already an existing {props.status} final XM for this donor.<br />
                        Are you sure you wish to request another?
                    </div>
                }
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSend}>Send Final XM Request</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RequestFinalXm;